function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useLayoutEffect, useRef, useState } from 'react';
import { Dropdown } from 'antd';
import { ResponsiveContext } from '../../context';
export default (function (props) {
  var _useContext = useContext(ResponsiveContext),
    onHandleTrigger = _useContext.onHandleTrigger,
    gridSizeMap = _useContext.state.gridSizeMap;
  var data = props.data;
  var domRef = useRef(null);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  useLayoutEffect(function () {
    if (domRef.current) {
      var rect = domRef.current.getBoundingClientRect();
      setItems([{
        label: '左右拆分',
        key: 'horizontal',
        disabled: rect.width < 60
      }, {
        label: '上下拆分',
        key: 'vertical',
        disabled: rect.height < 60
      }, {
        label: '刪除',
        key: 'onDelete'
      }]);
    } else {
      setItems([]);
    }
  }, [data.grid, gridSizeMap]);
  var onClick = function onClick(_ref) {
    var item = _ref.item,
      key = _ref.key;
    onHandleTrigger(key, data.com_id);
  };
  return /*#__PURE__*/React.createElement(Dropdown, {
    menu: {
      items: items,
      onClick: onClick
    },
    trigger: ['contextMenu']
  }, /*#__PURE__*/React.createElement("div", {
    ref: domRef,
    "data-com_id": data.com_id,
    "data-com_type": 'item',
    style: {
      gridArea: data.grid,
      boxSizing: 'border-box',
      margin: '5px',
      border: '1px solid #ccc'
    }
  }));
});